export const SET_USER = "SET_USER";

export const SET_LOADING_USER = "SET_LOADING_USER";
export const SET_USER_AUTHENTICATED = "SET_USER_AUTHENTICATED";
export const SET_AUTH_STATE = "SET_AUTH_STATE";
export const SET_USER_SUBSCRIPTION = "SET_USER_SUBSCRIPTION";
export const SET_MINDSET = "SET_MINDSET";
export const SET_TASK_LABELS = "SET_TASK_LABELS";
export const ADD_TASK_LABEL = "ADD_TASK_LABEL";
export const UPDATE_TASK_LABEL = "UPDATE_TASK_LABEL";
export const REMOVE_TASK_LABEL = "REMOVE_TASK_LABEL";
export const SET_LABEL_FILTERS = "SET_LABEL_FILTERS";
export const SET_SORT_ORDER = "SET_SORT_ORDER";
export const SET_TASK_CREATION_PREFERENCE = "SET_TASK_CREATION_PREFERENCE";
